<template>

  <div class="section">
    <div class="container">
      <div class="notification is-info">
        <h1 class="title">{{title}}</h1>

      </div>
      <div class="buttons">

        <span class="button is-info is-large" v-bind:class="unselected(number)"
              v-for="number in numbers" v-on:click="toggle(number)">{{number}}</span>

      </div>
      <div class="button" v-on:click="send">Starten!</div>
    </div>

  </div>
</template>

<script>
  import learnApiClient from '../LearnApiClient';

  export default {
    name: "multiplicationTables",
    computed: {
      title: function () {
        var operation =  Number(this.$router.currentRoute.params.operation);
        console.log()
        switch (operation) {
          case 1:
            return "Welche Plus-Aufgaben wollen wir trainieren?"
            break;

          case 2:
            return "Welche Minus-Aufgaben wollen wir trainieren?"
            break;

          case 3:
            return "Welches Einmaleins wollen wir trainieren?"
            break;

          case 4:
            return "Welche Geteilt-Aufgaben wollen wir trainieren?"
            break;

          default:
            return operation;
            block
        }

        return "";
      }
    },
    methods: {
      unselected: function (number) {
        if (this.checkedTables.includes(number)) {
          return "";
        } else {
          return "is-outlined";
        }

      },
      toggle: function (number) {
        if (this.checkedTables.includes(number)) {
          var index = this.checkedTables.indexOf(number);
          if (index !== -1) this.checkedTables.splice(index, 1);
        } else {
          this.checkedTables.push(number)
        }
      },


      send: async function () {
        var operation = this.$router.currentRoute.params.operation;
        var data = await learnApiClient.startAritmeticTable(this.checkedTables, operation);

        console.log(data);

        this.$store.commit("setWorksheet", data);
        var id = data.worksheetId;

        this.$router.push({name: "worksheet", params: {id}});

      }
    },
    data() {

      return {
        numbers: [2, 3, 4, 5, 6, 7, 8, 9, 10],
        checkedTables: []
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/math/selectArtimeticTables.vue